<p>
  Find a Health Center helps you search for
  <a
    href="https://bphc.hrsa.gov/about-health-center-program/what-health-center"
    target="_blank"
    class="usa-link usa-link--external"
    rel="noopener noreferrer"
    title="HRSA-funded health centers"
    >HRSA-funded health centers</a
  >. If you have geolocation turned on, you will automatically see Health Centers near you. Or, you can search near a
  specific place by typing a city, ZIP code, or a specific street address into the Location box; then click the
  magnifying glass or press enter/return on your keyboard
</p>
<ul class="padding-left-4">
  <li>The search area is set to a 5 mile radius when you begin, but you can set a wider search area if you like.</li>
  <li>You can export results to a printable PDF file. Only the 25 closest sites will appear in the PDF export.</li>
  <li>
    If you have questions, you can call the HRSA Contact Center at 877-464-4772 (TTY: 877-897-9910), 8 a.m. to 8 p.m.
    ET, weekdays (except Federal holidays).
  </li>
</ul>
<p>NOTE: The data used for this tool is current as of {{ refreshDate }} in the HRSA Data Warehouse.</p>
